export default __webpack_public_path__ + "static/media/admin.67419bf0.svg";